import _ from "lodash";
import client from "lib/apolloClient/client";
import {
  getConfigurationQuery,
  getStudentsCurriculumQuery,
  getStaffCurriculumQuery,
  getOrganizationDetailsQuery,
  getAssessmentTemplatesQuery,
  getPreferenceQuery,
} from "./ChildrenPageQuery";
import { configurationItemFragment } from "./ChildrenPageFragments";
import { generateConfigurationUid } from "modules/CommonGraphqlHelpers";
const BLANK_ARRAY = [],
  BLANK_OBJECT = {};

export const getConfigurationsFromCacheV2 = variables => {
  try {
    const result = client.readQuery({
      query: getConfigurationQuery,
      variables,
    });

    return _.get(result, "platform.configuration", []);
  } catch (error) {
    return {};
  }
};

export const getPreferencesFromCacheV2 = variables => {
  try {
    const result = client.readQuery({
      query: getPreferenceQuery,
      variables,
    });

    return _.get(result, "platform.preferences", []);
  } catch (error) {
    return {};
  }
};

export const getStudentsCurriculumFromCache = (
  userId,
  studentCurriculumProgramFilters
) => {
  try {
    const result = client.readQuery({
      query: getStudentsCurriculumQuery,
      variables: { ids: [userId], studentCurriculumProgramFilters },
    });

    return _.get(result, "platform.student[0]", []);
  } catch (error) {
    return {};
  }
};

export const getStaffCurriculumFromCache = variables => {
  try {
    const result = client.readQuery({
      query: getStaffCurriculumQuery,
      variables,
    });

    return _.get(result, "platform.staff[0]", []);
  } catch (error) {
    return {};
  }
};

export const readConfigurationFragmentV2 = (
  configurationVariables,
  configName
) => {
  try {
    const entityGroups = _.get(
      configurationVariables,
      "configurationEntityGroupFilters.0.configurationEntityGroups"
    );
    const id = generateConfigurationUid({ entityGroups, configName });
    const result = client.readFragment({
      id,
      fragment: configurationItemFragment.configurationItem,
      fragmentName: "configurationV2Item",
    });
    return result;
  } catch (error) {
    return {};
  }
};

export const readConfigurationFragmentByUID = ({ uid }) => {
  try {
    const result = client.readFragment({
      id: uid,
      fragment: configurationItemFragment.configurationItem,
      fragmentName: "configurationV2Item",
    });
    return result;
  } catch (error) {
    return {};
  }
};

export const writeConfigurationsToCacheV2 = (variables, data) => {
  try {
    client.writeQuery({
      query: getConfigurationQuery,
      variables,
      data,
    });
  } catch (e) {
    return {};
  }
};

export const writePreferencesToCacheV2 = (variables, data) => {
  try {
    client.writeQuery({
      query: getPreferenceQuery,
      variables,
      data,
    });
  } catch (e) {
    return {};
  }
};

export const getOrganizationDetailsFromCache = organizationId => {
  const queryData = client.readQuery({
    query: getOrganizationDetailsQuery,
    variables: {
      id: organizationId,
    },
  });

  return _.get(queryData, "node", {});
};

export const getAssessmentTemplatesFromCache = curriculumIds => {
  try {
    const queryData = client.readQuery({
      query: getAssessmentTemplatesQuery,
      variables: {
        curriculumIds,
      },
    });
    return _.get(queryData, "node", {});
  } catch (e) {
    return [];
  }
};
